import React from 'react';

import isActiveSection from './isActiveSection';

import {IconoirCustomContactList} from '@ey-xd/motif-icon';
import NavLink from './NavLink';

export default (label, currentProjectId) => ({
	id: 3,
	key: 3,
	url: 3, // CCS TopNav component sets link.url as the key for links this is set up to supress that warning on the console
	className: 'contactList',
	isLink: false,
	children: (
		<NavLink
			{...{label, icon: IconoirCustomContactList, solid: true, url: `/contacts?projectId=${currentProjectId}`}}
		/>
	)
});
